"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KalturaPlayerUtils = void 0;
var object_utils_1 = require("./object-utils");
var KalturaPlayerUtils = /** @class */ (function () {
    function KalturaPlayerUtils() {
    }
    KalturaPlayerUtils.getPlayerConfig = function (player, configPath, baseConfig, options) {
        var playerContribConfig = object_utils_1.ObjectUtils.get(player.config, configPath, {});
        return object_utils_1.ObjectUtils.mergeDefaults(playerContribConfig, baseConfig, options);
    };
    return KalturaPlayerUtils;
}());
exports.KalturaPlayerUtils = KalturaPlayerUtils;
//# sourceMappingURL=kaltura-player-utils.js.map